package nl.appstuff.padelchecker.site

import com.varabyte.kobweb.compose.ui.graphics.Color

/**
 * Color tokens matching the Padelchecker app theme.
 *
 * For Color.rgba(r, g, b, a) each component is 0-255.
 */
object SiteColors {
    // Brand
    val blue = Color.rgb(0x1A73E8)
    val blueDark = Color.rgb(0x0F57BE)
    val blueLight = Color.rgb(0xEAF1FC)

    // Backgrounds
    val backgroundLight = Color.rgb(0xF7F7F7)
    val backgroundVariantLight = Color.rgb(0xDDE5F4)
    val backgroundDark = Color.rgb(0x1F1F22)
    val backgroundVariantDark = Color.rgb(0x272A2F)

    // Text
    val textLight = Color.rgb(0x1E1E1E)
    val textDark = Color.rgb(0xFFFFFF)
    val textMutedLight = Color.rgb(0x4E5158)
    val textMutedDark = Color.rgb(0xCFD2D9)

    // Grays
    val grey1 = Color.rgb(0xDFDFDF)
    val grey2 = Color.rgb(0xCFCFCF)
    val grey3 = Color.rgb(0x8B8B8B)

    // Semantic
    val green = Color.rgb(0x17A35D)
    val white = Color.rgb(0xFFFFFF)
    val black = Color.rgb(0x000000)

    // Footer overlays
    val whiteMuted = Color.rgba(255, 255, 255, 217)
    val whiteGlass = Color.rgba(255, 255, 255, 51)
    val whiteDivider = Color.rgba(255, 255, 255, 36)
    val whiteDisabled = Color.rgba(255, 255, 255, 122)
    val whiteSecondary = Color.rgba(255, 255, 255, 196)
}
